import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { ManualVoucherApprovalWidget } from '@/widgets/manual-voucher-approval-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'filter.statuses': z.array(z.string()).optional(),
  'filter.dateFrom': z.string().optional(),
  'filter.dateTo': z.string().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/canteen/manual-voucher-approval')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper
      title={t(
        'Заявки для администраторов школ на подтверждение фиксации ручного учёта посещения столовой и получения питания учащихся'
      )}
    >
      <ManualVoucherApprovalWidget />
    </PageWrapper>
  )
}
